import { Box, type SxProps, type Theme } from "@mui/material";
import { useFieldValue, type FieldProps } from "react-admin";
import { DataValue } from "./presentation";

interface ValueFieldProps extends FieldProps {
  sx?: SxProps<Theme>;
  maxWidth?: number;
  copy?: boolean;
}

function RecordValueField({
  date = false,
  copy = false,
  ...props
}: ValueFieldProps & { date?: boolean }) {
  const value = useFieldValue(props);
  const empty = value == null || value === "";
  const label =
    typeof props.label === "string" ? props.label : props.source || "value";
  return (
    <Box component="span" className={props.className} sx={props.sx}>
      <DataValue
        value={empty ? props.emptyText : value}
        label={label}
        copy={copy && !empty}
        date={date}
        maxWidth={props.maxWidth}
      />
    </Box>
  );
}

export function CopyableField(props: ValueFieldProps) {
  return <RecordValueField {...props} copy />;
}

export function DateTimeField(props: ValueFieldProps) {
  return <RecordValueField {...props} date />;
}
